module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/integrated_icon-26ffa64a55f7aac8b45ab18fdb53b21e.png";